import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BoxSpg, isArrayEmpty, isNotEmpty } from "@duosoftbg/nacid-components";
import { useWatch } from "react-hook-form";
import { Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import {
  clearGradingScaleDetails,
  gradingScaleDetailsThunk,
} from "../../../../../../store/redux/slice/AppData/gradingScaleDetails ";
import { useAppDispatch } from "@duosoftbg/nacid-frontoffice-components";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../store/redux/store";

interface GradingScaleDetailsSectionProps {
  gradingScaleWarning?: string;
}

const GradingScaleDetailsSection = ({ gradingScaleWarning = undefined }: GradingScaleDetailsSectionProps) => {
  const { t } = useTranslation();
  const gradingScale = useWatch({ name: "gradingScale" });
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (gradingScale?.id) {
      dispatch(gradingScaleDetailsThunk(gradingScale.id));
    } else {
      dispatch(clearGradingScaleDetails());
    }
  }, [gradingScale, dispatch]);
  const gradingScaleDetails = useSelector((state: RootState) => state.AppData.gradingScaleDetails.data);
  if (isArrayEmpty(gradingScaleDetails)) {
    return null;
  }

  return (
    <BoxSpg style={{ marginTop: "50px", marginBottom: "20px", marginLeft: "10px", width: "95%" }}>
      {gradingScaleWarning && (
        <Alert variant="outlined" severity="warning" sx={{ border: "none" }}>
          {t(gradingScaleWarning)}
        </Alert>
      )}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: "none" }}>{t("h.gradingScaleDescription")}</TableCell>
              <TableCell sx={{ border: "none" }} align="right">
                {t("h.gradingScaleGrades")}
              </TableCell>
              <TableCell sx={{ border: "none" }} align="right">
                {t("h.gradingScaleGradesEquivalent")}
              </TableCell>
              <TableCell sx={{ border: "none" }} align="right">
                {t("h.gradingScaleGradesEquivalentText")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {gradingScaleDetails &&
              gradingScaleDetails.map((detail) => (
                <TableRow key={detail.id} sx={{ borderBottom: "1px solid #e0e0e0" }}>
                  <TableCell sx={{ border: "none" }}>{detail.gradingScale.name}</TableCell>
                  <TableCell sx={{ border: "none" }} align="right">
                    {detail.symbolValues && isNotEmpty(detail.symbolValues.trim())
                      ? detail.symbolValues
                      : isNotEmpty(detail.minValue) && isNotEmpty(detail.maxValue)
                        ? `${detail.minValue} - ${detail.maxValue}`
                        : isNotEmpty(detail.minValue)
                          ? `${detail.minValue}`
                          : isNotEmpty(detail.maxValue)
                            ? `${detail.maxValue}`
                            : ""}
                  </TableCell>
                  <TableCell sx={{ border: "none" }} align="right">
                    {detail.gradeEquivalence.bulgarianGrade}
                  </TableCell>
                  <TableCell sx={{ border: "none" }} align="right">
                    {detail.gradeEquivalence.name}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </BoxSpg>
  );
};

export default GradingScaleDetailsSection;
